import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';

import {
    FETCH_PLAYER_GOLF_STATS,
    FETCH_PLAYER_GOLF_STATS_SUCCESS,
    FETCH_PLAYER_GOLF_STATS_FAIL,
    FETCH_ALL_DRIVE_GOLF_STATS,
    FETCH_ALL_DRIVE_GOLF_STATS_SUCCESS,
    FETCH_FILTERED_DRIVE_GOLF_STATS,
    FETCH_FILTERED_DRIVE_GOLF_STATS_SUCCESS,
    FETCH_ALL_APPROACH_GOLF_STATS,
    FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS,
    FETCH_FILTERED_APPROACH_GOLF_STATS,
    FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS,
    FETCH_ALL_CHIP_GOLF_STATS,
    FETCH_ALL_CHIP_GOLF_STATS_SUCCESS,
    FETCH_FILTERED_CHIP_GOLF_STATS,
    FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS,
    FETCH_ALL_PUTT_GOLF_STATS,
    FETCH_ALL_PUTT_GOLF_STATS_SUCCESS
} from '../actions/ActionTypes';

// worker
export function* fetchPlayerGolfStats(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/player/stats');

        yield put({
            type: FETCH_PLAYER_GOLF_STATS_SUCCESS,
            playerGolfStats: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PLAYER_GOLF_STATS_FAIL,
            playerGolfStats: {}
        });
    }
}

export function* fetchAllDriveGolfStats(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/shot/stats/drive');

        yield put({
            type: FETCH_ALL_DRIVE_GOLF_STATS_SUCCESS,
            driveGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchFilteredDriveGolfStats(action) {
    try {
        let url = '/gcs-golfcommunity/api/v2/shot/stats/drive';
        if (action.clubIds && action.clubIds.length > 0) {
            url += '?club-ids=' + action.clubIds[0];
            for (let i = 1; i < action.clubIds.length; i++) {
                url += '-' + action.clubIds[i];
            }
        }
        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_FILTERED_DRIVE_GOLF_STATS_SUCCESS,
            driveGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchAllApproachGolfStats(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/shot/stats/approach');

        yield put({
            type: FETCH_ALL_APPROACH_GOLF_STATS_SUCCESS,
            approachGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchFilteredApproachGolfStats(action) {
    try {
        let url = '/gcs-golfcommunity/api/v2/shot/stats/approach';
        if (action.clubIds && action.clubIds.length > 0) {
            url += '?club-ids=' + action.clubIds[0];
            for (let i = 1; i < action.clubIds.length; i++) {
                url += '-' + action.clubIds[i];
            }
        }
        const response = yield call(golfApi.get, url);

        /*  GOLFAPP-5197 - per Casey Stalnaker
            If the original json returned from the endpoint contains properties percentHitGreen10, percentHitGreen20, or percentHitGreen20+
            we know that the user has CT10 or other shot tracking sensors. In this case we should force the usingClubTrack boolean to true.
            This setting will ensure that we are showing concentric rings in the approach chart inside of Unity.
        */
        let usingClubtrack = false;
        if (
            response.data.percentHitGreen10 !== null ||
            response.data.percentHitGreen20 !== null ||
            response.data.percentHitGreen20Plus !== null
        ) {
            usingClubtrack = true;
        }

        response.data.usingClubtrack = usingClubtrack;

        yield put({
            type: FETCH_FILTERED_APPROACH_GOLF_STATS_SUCCESS,
            approachGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchAllChipGolfStats(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/shot/stats/chip');

        yield put({
            type: FETCH_ALL_CHIP_GOLF_STATS_SUCCESS,
            chipGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchFilteredChipGolfStats(action) {
    try {
        let url = '/gcs-golfcommunity/api/v2/shot/stats/chip';
        if (action.clubIds && action.clubIds.length > 0) {
            url += '?club-ids=' + action.clubIds[0];
            for (let i = 1; i < action.clubIds.length; i++) {
                url += '-' + action.clubIds[i];
            }
        }
        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS,
            chipGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

export function* fetchAllPuttGolfStats(action) {
    try {
        const response = yield call(golfApi.get, '/gcs-golfcommunity/api/v2/shot/stats/putt');

        yield put({
            type: FETCH_ALL_PUTT_GOLF_STATS_SUCCESS,
            puttGolfStats: response.data
        });
    } catch (e) {
        // handling error
    }
}

// watcher
export const golfStatsSagas = [
    takeEvery(FETCH_PLAYER_GOLF_STATS, fetchPlayerGolfStats),
    takeEvery(FETCH_ALL_DRIVE_GOLF_STATS, fetchAllDriveGolfStats),
    takeEvery(FETCH_FILTERED_DRIVE_GOLF_STATS, fetchFilteredDriveGolfStats),
    takeEvery(FETCH_ALL_APPROACH_GOLF_STATS, fetchAllApproachGolfStats),
    takeEvery(FETCH_FILTERED_APPROACH_GOLF_STATS, fetchFilteredApproachGolfStats),
    takeEvery(FETCH_ALL_CHIP_GOLF_STATS, fetchAllChipGolfStats),
    takeEvery(FETCH_FILTERED_CHIP_GOLF_STATS, fetchFilteredChipGolfStats),
    takeEvery(FETCH_ALL_PUTT_GOLF_STATS, fetchAllPuttGolfStats)
];
